const GET_STATE       = '/api/attendances/get-state'
const CHECK_IN        = '/api/attendances/check-in'
const CHECK_OUT       = '/api/attendances/check-out'
const SEND_REQUEST    = '/api/attendances/send-request'
const GET_LIST        = '/api/attendances/get-list'
const GET_REPORT      = '/api/attendances/get-report'
const CONFIRM_REQUEST = '/api/attendances/confirm-request'

let services = {
    getState(axios, success, fail) {
        axios.get(GET_STATE)
            .then((response) => {
                let dataJson = response.data
                success(dataJson)
            })
            .catch((error) => {
                fail(error)
            })
    },
    checkIn(axios, form, success, fail) {
        axios.post(CHECK_IN, form)
            .then((response) => {
                let dataJson = response.data
                success(dataJson)
            })
            .catch((error) => {
                fail(error)
            })
    },
    checkOut(axios, form, success, fail) {
        axios.post(CHECK_OUT, form)
            .then((response) => {
                let dataJson = response.data
                success(dataJson)
            })
            .catch((error) => {
                fail(error)
            })
    },
    sendRequest(axios, form, success, fail) {
        axios.post(SEND_REQUEST, form)
            .then((response) => {
                let dataJson = response.data
                success(dataJson)
            })
            .catch((error) => {
                fail(error)
            })
    },
    confirmRequest(axios, form, success, fail) {
        axios.post(CONFIRM_REQUEST, form)
            .then((response) => {
                let dataJson = response.data
                success(dataJson)
            })
            .catch((error) => {
                fail(error)
            })
    },
    getList(axios, conditions, success, fail) {
        let query = {
            params: conditions
        }
        axios.get(GET_LIST, query)
            .then((response) => {
                let dataJson = response.data
                success(dataJson)
            })
            .catch((error) => {
                fail(error)
            })
    },
    getReport(axios, conditions, success, fail) {
        let query = {
            params: conditions
        }
        axios.get(GET_REPORT, query)
            .then((response) => {
                let dataJson = response.data
                success(dataJson)
            })
            .catch((error) => {
                fail(error)
            })
    },
}

export default services